
/*
 * VNCtask : VNCtask – the easy to use Task Management & To-Do List application. Stay organized. Anytime! Anywhere!
 * Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, version 3 of the License.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. Look for COPYING file in the top folder.
 * If not, see http://www.gnu.org/licenses/.
 */

import { Injectable } from "@angular/core";
import { Observable, Subject, combineLatest, forkJoin } from "rxjs";
import { map, take } from "rxjs/operators";
import { CommonUtil } from "../../common/utils/common.utils";
import { Task, TaskComment, ICompact, Project, User, List, PendingOperation, Tag, SearchQuery, Location } from "../models";
import { DatabaseReady } from "../../actions/app";
import { environment } from "../../../environments/environment";
import { IndexedDBService } from "./db/indexedDB.service";


import { DatabaseOpsLayer } from "./database-ops.layer";

@Injectable({
  providedIn: "root"
})
export class DatabaseService extends DatabaseOpsLayer {
  constructor() {
    super();
    this.dbServiceImpl = new IndexedDBService();
    console.log("[SQLITE][DatabaseService] constructor, isElectron = " + environment.isElectron);


    if (environment.isElectron) {
      this.setup().subscribe(() => {
        console.log("[SQLITE][DBElectronWrapper] database ready");
        this.store.dispatch(new DatabaseReady());
      });
    } else {
      document.addEventListener("deviceready", this.deviceReady.bind(this), false);
    }

    this.broadcaster.on<any>("appComponentOnDestroy").subscribe($event => {
      if (CommonUtil.isSQLSupported()) {
        this.close().subscribe(() => {
          console.log("[SQLITE] database closed");
        });
      }
    });
  }

}

